<template>
  <div class="question-view text-drag">
    <div class="quest">
      <div class="title">
        <vue-mathjax :formula="form.title" @onRenderComplete="mathjaxRes" :safe="false"/>
      </div>

      <div class="choice-list">
        <span class="choice-single" v-for="(its, idx) in choice" :id="'single' + idx" :key="idx" draggable="true" @dragstart="dragStart($event, idx)">
          <vue-mathjax :formula="its.content" @onRenderComplete="mathjaxRes" :safe="false"/>
        </span>
      </div>

      <div class="question-list">
        <div class="single" :data-id="its.id" v-for="(its, idx) in question" :key="idx">
        <!-- {{ its.arr }} -->
          <vue-mathjax :formula="its.arr" :safe="false"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let pLeft = 'PARENTHESISLEFT', pRight = 'PARENTHESISRIGHT'

export default {
  props: ['form'],
  data() {
    let letter = new Array(26).fill().map((its, idx) => its = String.fromCharCode(65 + idx))

    return {
      letter,
      topic: '',
      
      choice: [],
      question: [],

      useMathjaxNum: 1,
      mathjaxNum: 0
    }
  },
  methods: {
    findImageLinks(text) {
      // 匹配常见的图片链接格式，如 .jpg, .jpeg, .png, .gif 等
      const regex = /(https?:\/\/.*?\.(?:png|jpg|jpeg|gif))/gi;
      let match;
      const imageLinks = [];

      // 使用正则表达式在文本中查找匹配的图片链接
      while ((match = regex.exec(text)) !== null) {
          imageLinks.push(match[0]);
      }

      return imageLinks;
    },
    mathjaxRes() {
      this.mathjaxNum ++
      // console.log('文本拖拽题 （1）', this.useMathjaxNum)
      if(this.mathjaxNum >= this.useMathjaxNum) this.$emit('onRenderComplete')
    },
    dragStart(e, idx) {
      // e.preventDefault()
      // console.log(e.target)
      e.dataTransfer.setData('textDragMsg', idx)
    },

    dragover(e) {
      e.preventDefault()
    },

    drop(e, ) {
      let textDragMsg = e.dataTransfer.getData('textDragMsg')
      
      // 存在 e.target 为子节点  不是「填空区域」获取父节点后再作处理
      let eareBox = e.target.classList.contains('input') ? e.target : e.target.parentNode
      // 获取拖拽的节点
      let dragNode = document.querySelector('#single' + textDragMsg)
      // console.log(dragNode.innerHTML)
      eareBox.innerHTML = dragNode.innerHTML

    },

    // 填空区域点击事件
    clickFillEare(e) {
      // 存在 e.target 为子节点  不是「填空区域」获取父节点后再作处理
      let eareBox = e.target.classList.contains('input') ? e.target : e.target.parentNode
      eareBox.innerText = ''
    },
    changeChoice(content) {
      content = content.replaceAll('\\left(', pLeft).replaceAll('\\right)', pRight)
      // let regex = /\(\)/g, 
      let regex = /\$\$([^$]*)\$\$|\$([^$]*)\$/g,
      // regex1 = /(?<!\\left)(?<!\\right)\(([^()]*)\)/g,
      regex1 = /@(.*?)#/g,
      regexMap = {
        over: /\$(([^$]*)\\over([^$]*))\$/,
        frac: /\$(([^$]*)\\frac([^$]*))\$/
      }, res, grade, arr = []
      // , subscript = 0

      grade = content.match(regex)
      res = content.match(regex1)
      if(grade) {
        for(let i = 0; i < grade.length; i++) {
          let its = grade[i],
          over = its.match(regexMap.over),
          frac = its.match(regexMap.frac)
          // 分数结构
          if(over) {
            // 处理數据 判断是否被()括住
            for(let i = 2; i < over.length; i++) {
              let val = over[i].match(regex1)
              // 在替换之前将 \left(, \right) 转为()
              over[i] = over[i].replaceAll('\\left(', '(').replaceAll('\\right)', ')')
           
              if(val) {
                let constVal = over[i].split('()')
                over[i] = {fill: true, val: constVal}
              }
              else over[i] = {fill: false, val: over[i]}
            }

            // 判断fill 是否为true
            let isFill = over.some(its => its.fill)
            if(!isFill) {
              continue ;
            }

            let [, , child, parent] = over

            arr.push(...[
              { text: '', answerArea: true, type: 'decimals', map: [
                  child, parent
                ]
              }, 
            ])
            
            let echoHtml = `
            <div class="some-as">
              ${ child.fill ? 
                  `
                  <div class="some-child">
                    ${
                      child.val.map((ele, idx) => {
                        if(idx == 0) {
                          return `<span>${ele}</span>`
                        } else {
                          return `<div class="input">
                          </div>
                          <span>${ele}</span>
                          `
                        }
                      }).join('')
                    }
                  </div>
                  ` :
                  `<div class="numerator">${child.val}</div>` }
              ${ parent.fill ? 
                  `
                  <div class="some-child">
                    ${
                      parent.val.map((ele, idx) => {
                        if(idx == 0) {
                          return `<span>${ele}</span>`
                        } else {
                          return `<div class="input">
                          </div>
                          <span>${ele}</span>
                          `
                        }
                      }).join('')
                    }
                  </div>
                  ` :
                  `<div class="denominator">${parent.val}</div>` }
            </div>
            `
            content = content.replace(its, echoHtml)
          }
          // 带分数结构
          if(frac) {
            console.clear()
            // console.log(frac)
            // integer 整数部分，fraction 分数部分
            let [, , integer, fraction] = frac
            , fractionRegex = /\{.*?\}/g
            // 取出同时去除首尾的大括号
            , [child, parent] = fraction.match(fractionRegex)
                              .map(s => s.slice(1, -1))
            
            let echoData = [integer, child, parent]
            // 处理數据 判断是否被()括住
            for(let i = 0; i < echoData.length; i++) {
              // console.log(echoData[i])
              let val = echoData[i].match(regex1)
              // 在替换之前将 \left(, \right) 转为()
              echoData[i] = echoData[i].replaceAll('\\left(', '(').replaceAll('\\right)', ')')
              // console.log(val)
              // console.log('-------')
              if(val) {
                let constVal = echoData[i].split('()')
                echoData[i] = {fill: true, val: constVal}
              } else echoData[i] = {fill: false, val: echoData[i]}
            }
            // console.log(echoData)
            // 判断fill 是否为true
            // let isFill = echoData.some(its => its.fill)
            // if(!isFill) {
            //   continue ;
            // }

            let echoHtml = `
            <div class="mixed-number">
              ${ echoData[0].fill ? 
                  `
                  <div class="some-child">
                    ${
                      echoData[0].val.map((ele, idx) => {
                        if(idx == 0) {
                          return `<span>${ele}</span>`
                        } else {
                          return `<div class="input">
                          </div>
                          <span>${ele}</span>
                          `
                        }
                      }).join('')
                    }
                  </div>
                  `:
                  `<div class="mixed">${echoData[0].val}</div>` }
              <div class="some-as">
                ${ echoData[1].fill ? 
                  `
                  <div class="some-child">
                    ${
                      echoData[1].val.map((ele, idx) => {
                        if(idx == 0) {
                          return `<span>${ele}</span>`
                        } else {
                          return `<div class="input">
                          </div>
                          <span>${ele}</span>
                          `
                        }
                      }).join('')
                    }
                  </div>
                  `:
                  `<div class="numerator">${echoData[1].val}</div>` }
  
                ${ echoData[2].fill ? 
                  `
                  <div class="some-child">
                    ${
                      echoData[2].val.map((ele, idx) => {
                        if(idx == 0) {
                          return `<span>${ele}</span>`
                        } else {
                          return `<div class="input">
                          </div>
                          <span>${ele}</span>
                          `
                        }
                      }).join('')
                    }
                  </div>
                  ` :
                  `<div class="denominator">${echoData[2].val}</div>` }
              </div>
            </div>
            `
            content = content.replace(its, echoHtml)
          }
        }
      }

      if(res) {
        for(let i = 0; i < res.length; i++) {
          let echoHtml = `
          <div class="input">
          </div>`
          content = content.replace(res[i], echoHtml)
        }
      }
      // content = content.replaceAll('\\left(', '(').replaceAll('\\right)', ')')
      content = content.replaceAll(pLeft, '(').replaceAll(pRight, ')')
      return `<div class="single-flex">${content}</div>`
    },
  },
  created() {
    let content = JSON.parse(this.form.content)
    , deWeight = []
    // console.log(content)
    // let question = JSON.parse(JSON.stringify(content.question)).filter(its => its.content.trim() != '' && its)
    this.choice = JSON.parse(JSON.stringify(content.choice)).filter(its => {
      /// 匹配出图片链接，并赋予标签
      let imgs = this.findImageLinks(its.content)
      for(let i = 0; i < imgs.length; i++) {
        let imgDomStr = `<img src="${imgs[i]}" />`
        its.content = its.content.replace(imgs[i], imgDomStr)
      }

      if(!deWeight.includes(its.content)) {
        deWeight.push(its.content)
      } else {
        return false
      }
      
      return its.content && its
    })

    for(let i = 0; i < this.question.length; i++) {
      let item = this.question[i]

      for(let j = 0; j < item.arr.length; j++) {
        if(!item.arr.answerArea) this.useMathjaxNum++
      }
    }

    this.question = JSON.parse(JSON.stringify(this.form.choices)).filter(its => {
        /// 匹配出图片链接，并赋予标签
        let imgs = this.findImageLinks(its.value)
        for(let i = 0; i < imgs.length; i++) {
          let imgDomStr = `<img src="${imgs[i]}" class="text-img" />`
          its.value = its.value.replace(imgs[i], imgDomStr)
        }
        
        return its.value && its
      })
      .map(its => {
        // 还原答案
        return {id: its.id, arr: this.changeChoice(its.value)}
      })
      // console.log(this.question)
      this.$nextTick(() => {
        let doms = document.querySelectorAll('.text-drag .input') 

        for(let i = 0; i < doms.length; i++) {
          doms[i].onclick = (e) => {
            // console.log('click')
            this.clickFillEare(e)
          }
          doms[i].ondrop = (e) => this.drop(e)
          doms[i].ondragover = this.dragover
        }

      })
  }
}
</script>

<style scoped lang="scss">
.question-view {
  width: 100%;
  height: 100%;
  padding: 0px 0;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 10px;

    .title {
      font-size: 15px;
      color: #333;
    }

    .choice-list {
      margin-top: 20px;
      display: flex;
      justify-content: flex-start;
      align-content: flex-start;
      flex-wrap: wrap;
      box-sizing: border-box;
      .choice-single {
        min-width: 100px;
        height: 54px;
        margin: 0 10px 10px 0;
        padding: 0 5px;
        background-color: #f8ae64;
        border-radius: 8px;
        box-shadow: 1px 2px 2px 1px #ccc;
        font-size: 14px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        user-select: none; 
        position: relative;

        & > span {
          display: inline-block;
          text-align: center;
        }

        &:hover {
          opacity: .8;
        }
      }
    }
    
    .question-list {
      margin-top: 20px;
      width: 100%;
      padding: 0;

      .single {
        width: 100%;
        // height: 32px;
        padding: 0 10px;
        box-sizing: border-box;
        border-radius: 10px;
        // border: 2px solid #fcd2ab;
        // background-color: #fcd2ab;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 10px;
        cursor: pointer;
      }
    }
}
</style>

<style lang="scss">
.text-drag {

  .choice-single img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: 100%;
    width: auto;
  }

  .single-flex {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .input {
      min-width: 100px;
      height: 40px;
      background-color: #fcd2ab;
      border-radius: 10px;
      padding: 0 10px;
      box-sizing: border-box;
      outline: none;
      border: none;
      margin: 0 10px;
      display: flex;
      align-items: center;
      position: relative;
      justify-content: center;
      position: relative;

      & > span {
        display: flex;
        justify-content: center;

        img {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          margin: auto;
          width: auto;
          height: 40px;
        }
      }
    }
  
    .some-as {
      display: inline-block;
      margin: 0 5px;
      position: relative;
      color: #333;
      vertical-align: middle;
  
      &:after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        height: 1px;
        width: 100%;
        background-color: #333;
      }
  
      .some-child {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 8px 0;
      }
      .numerator, .denominator {
        margin: 5px 0;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px;
      }
  
      .numerator.fill, .denominator.fill {
        border-radius: 10px;
        background-color: #fcd2ab;
        outline: none;
        border: none;
        width: 60px;
        text-align: center;
        padding: 5px;
        box-sizing: border-box;
      }
    }
  
    .mixed-number {
      display: inline-flex;
      align-items: center;
      .mixed {
        color: #333;
      }
  
      .mixed.fill {
        border-radius: 10px;
        background-color: #fcd2ab;
        outline: none;
        border: none;
        width: 60px;
        height: 40px;
        text-align: center;
        padding: 5px;
        color: #333;
      }
    } 
  }

}
</style>